import { Box, styled, Typography } from '@mui/material'

export const FileUploadHeader = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '16px 24px',
  borderBottom: '1px solid #F0F0F0',
}))

export const StyledTypography = styled(Typography)(() => ({
  fontSize: '20px',
}))
